import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/hooks/index';

type Params = {
  chatInstanceId: number;
  queryIdentifier: string;
};

export const useDownloadQueryTable = (params: Params) => {

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `query:download-table`,
      params,
    ],
    queryFn: ({ queryKey: [, data] }) => {
      return apiClient.queries.downloadQueryTable({
        chatInstanceId: data.chatInstanceId,
        queryIdentifier: data.queryIdentifier,
      });
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      onResponse: res => ({
        filename: res.fileName,
        type: 'blob',
        value: res.blob,
      }),
    },
  });

};